export interface QuotaAlert { exceeds: boolean; excess: number; hasQuota: boolean }

/** Sin cupo registrado se trata como 0: cualquier inscrito excede. */
export function quotaAlert(used: number, contracted: number | null | undefined): QuotaAlert {
  const cap = contracted ?? 0;
  return { exceeds: used > cap, excess: Math.max(0, used - cap), hasQuota: contracted != null };
}
